module.exports = __webpack_public_path__ + "static/media/Cotizador2.9ebe1165.png";